
<!--订单确认时选择线下门店-->


<template>
  <div class="storeList">
    <van-loading v-if="!finished"
                 :style="{height:$store.state.winHeight}"
                 color="#1989fa" vertical type="spinner"/>
    <div v-else>
      <div v-for="item in stores" :key="item.id" class="store-item">
        <div class="tag-shop-distance" @click="toCommit(item.id)">
          <div class="tag-shop">
            <span v-show="item.wasMinDistance" class="tag">离我最近</span>
            <span class="shop">{{item.shop_name}}</span>
          </div>
          <div v-if="item.distance!=-1" class="distance">
            距您<span>{{item.distance|transformPrice}}</span>km
          </div>
        </div>
        <div class="store-address-and-map">
          <div class="address" @click="toCommit(item.id)">{{item.address}}</div>
          <div class="to-map" v-if="item.latitude && item.longitude" @click="toMap(item)">查看地图</div>
          <div class="to-map" v-else>无位置信息</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { List, Toast, Loading } from 'vant';
import Vue from 'vue';
import { isWechat } from '../../common/js/tools';

require('geo-tools');

Vue.use(List).use(Toast).use(Loading);
export default {
  name: 'OfflineStore',
  data: () => ({
    finished: false,
    stores: [],
  }),
  computed: {
    userGeolocation() {
      return this.$store.state.userGeolocation;
    },
  },
  created() {
    this.$http.get('/api/shop/solidshops?type=0').then((resp) => {
      this.finished = true;
      const dataList = resp.data.map((v) => {
        const item = v;
        item.wasMinDistance = false;
        item.distance = -1;
        return item;
      });

      if (this.userGeolocation === null) {
        // Toast('当前无法为你显示最近门店');
        dataList.forEach((v) => {
          this.stores.push(v);
        });
        return;
      }
      // 缺少门店位置信息的列表
      const notLocation = [];
      const hasLocation = dataList.filter((v) => {
        if (v.latitude && v.longitude) return true;
        notLocation.push(v);
        return false;
      });
      let minDistance = -1; // 最短距离，初始值为-1，表示没有初始化过
      let minOfflineStore = null; // 最短距离门店信息对象
      let minOfflineIndex = 0; // 最小门店信息，在数组中的索引位置，用于在将其提至数组顶部时，需要用到该索引
      hasLocation.forEach((v, i) => {
        const item = v;
        // eslint-disable-next-line no-undef
        item.distance = distance(
          v.latitude, v.longitude,
          this.userGeolocation.latitude,
          this.userGeolocation.longitude,
        );
        if (minDistance === -1) {
          minOfflineStore = item;
          minOfflineIndex = i;
          minDistance = item.distance;
        } else if (item.distance < minDistance) {
          minOfflineStore = item;
          minOfflineIndex = i;
          minDistance = item.distance;
        }
      });
      minOfflineStore.wasMinDistance = true;
      hasLocation.splice(minOfflineIndex, 1);
      hasLocation.unshift(minOfflineStore);
      hasLocation.concat(notLocation).forEach((v) => {
        this.stores.push(v);
      });
    });
  },
  methods: {
    toCommit(id) {
      const chooseStore = this.stores.find((v) => v.id === id);
      this.$store.commit('updateChooseOfflineStore', chooseStore);
      this.$router.back();
    },
    toMap(item) {
      /**
       * 如果当前环境是在微信中，那么直接调用微信的内置浏览器，查看地图,
       * 如果发生调用错误，那么就会跳转到浏览器地图。
       * */
      if (isWechat()) {
        wx.openLocation({
          latitude: item.latitude,
          longitude: item.longitude,
          name: item.shop_name,
          fail: () => {
            this.toBrowserMap(item);
          },
        });
      } else {
        this.toBrowserMap(item);
      }
    },
    toBrowserMap(item) {
      this.$router.push({
        name: 'store_map',
        query: {
          lat: item.latitude,
          lng: item.longitude,
          id: item.id,
          name: item.shop_name,
          address: item.address,
        },
      });
    },
  },
};
</script>

<style scoped>
  .storeList{
    font-weight: bold;
  }
  .van-loading{
    text-align: center;
  }
  .van-loading>span{
    margin-top: 40%;
  }
  .store-item {
    padding: 1rem 0.7rem;
    border-bottom: 1px solid #EFEFEF;
    background-color: white;
  }

  .tag-shop-distance, .store-address-and-map {
    display: flex;
    justify-content: space-between;
  }
  .tag-shop{
    flex: 1 0 70%;
  }
  .tag{
    background-color: #DF1417;
    color: white;
    font-size: 0.9rem;
    padding: 0.3rem 1rem;
    border-radius: 1.6rem;
    margin-right: 0.6rem;
    font-weight: lighter;
  }
  .distance {
    font-size: 0.9rem;
    flex: 1 0 30%;
    text-align: center;
  }

  .distance > span, .to-map {
    color: #DF1417;
  }

  .store-address-and-map {
    margin-top: 1rem;
  }

  .address {
    width: 70%;
    font-size: 0.9rem;
    color: #666666;
  }

  .to-map{
    width: 20%;
    font-size: 0.8rem;
  }
</style>
